module.exports = __webpack_public_path__ + "static/SectionGeometry-cfaa8b07a07beac89f4af3c7e294fb32.svg";